import { useState, useMemo, useEffect } from "react";
import { Fragment } from "react";


import { getLabel, getLanguage } from "../../tools/Dictionary";
import { dataValidator } from "../../tools/dataValidator";
import useMount from "../../hooks/useMount";
import useAfterMount from "../../hooks/useAfterMount";
import superheatApi from "../../api/superheatApi";
import AlertModal from "../Commons/AlertModal";

import { FaRegCircle } from "react-icons/fa";
import { MdOutlineLightMode, MdOutlineMotionPhotosOff } from "react-icons/md";
import { LiaHandPointer } from "react-icons/lia";
import "./Component.css";

const ComponentSuperheat = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Auth = props.Auth;
  const ConvertTemp = Auth.User.temperatureUnit.code == "F" ? true : false;
  const Data = props.Data;
  const Value = props.Value;
  const Edit = props.Edit;
  const Error = props.Error;
  const OnChangeValue = props.OnChangeValue;
  const HandleKeyDown = props.HandleKeyDown;



  //State
  const [form, setForm] = useState({
    temperature: Value && Value.parameter ? Value.parameter.temperature : "",
    temperatureF: Value && Value.parameter ? Math.round(((Value.parameter.temperature * 9 / 5) + 32) * 10) / 10 : "",
    pressure: Value && Value.parameter ? Value.parameter.pressure : ""
  });
  const [error, setError] = useState({});
  const [superheat, setSuperheat] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() => {

    loadData();

  });

  const loadData = async() => {



    try
    {

      setLoading(true);

      let response = await superheatApi.getSuperheats({
        select: `_id,refrigerant,tolerance,value`, filter: "refrigerant eq '" + Data.data.refrigerant + "'"});


      if (!response.Success)
      {

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }


      setSuperheat(response.Data[0] || undefined);

      setLoading(false);

    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };

  const onChangeTemperature = (e) => {

    let temperature = e.target.value;


    let temperatureF = ConvertTemp ? temperature : ((temperature * 9 / 5) + 32).toFixed(2);
    temperature = ConvertTemp ? ((temperature - 32) * 5 / 9).toFixed(2) : temperature;

    onValidateField("temperature", temperature); //Validate field value

    setForm(form => ({
      ...form,
      temperature,
      temperatureF
    }));

  };

  const onChangePressure = (e) =>
  {

    let pressure = e.target.value;

    onValidateField("pressure", pressure); //Validate field value

    setForm(form => ({
      ...form,
      pressure
    }));

  };


  useEffect(() => {

    if (!Edit){

      let currentValidation = dataValidator([
        { field: "temperature", value: form.temperature, listValidation: ["required", "max:6", "number"] },
        { field: "pressure", value: form.pressure, listValidation: ["required", "max:10", "number"] },
      ]);

      if (currentValidation.every(v => v.valid)){

        //Convert Temp
        let convertTemp = form.temperature; //Auth.User.temperatureUnit.code == "F" ? (form.temperature - 32) * 5 / 9 : form.temperature

        if (!superheat || !superheat.value) return;

        let foundResult = superheat.value.reduce((prev, curr) => {

          let d1 = Math.abs(prev.temperature - convertTemp) + Math.abs(prev.pressure - form.pressure);
          let d2 = Math.abs(curr.temperature - convertTemp) + Math.abs(curr.pressure - form.pressure);

          return d1 === d2 ? ((prev.result > curr.result) ? prev : curr) : (d1 < d2) ? prev : curr;

        });


        if (foundResult) 
          OnChangeValue(foundResult.result.toString(), Data, {temperature: form.temperature, pressure: form.pressure});
        else
          OnChangeValue(undefined, Data, { temperature: form.temperature, pressure: form.pressure });



      }else{

        OnChangeValue(undefined, Data, { temperature: form.temperature, pressure: form.pressure });

      }

    }

  }, [form.temperature, form.pressure, Edit, superheat, Data]);

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "temperature";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:6", "number"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "pressure";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:10", "number"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }



    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  return (
    <Fragment>
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="component_row_label" style={Data.data.textStyle}>
        {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
      </div>
      <div className="component_row_label" style={{ fontWeight: "bold", color: "#4d4d4d" }}>
        {getLabel("ComponentEntity", "Temperature")}
      </div>
      <div className="component_row_input">
        <input
          className="page_text_input component_text_input"
          type="text"
          style={{marginLeft: "20px"}}
          onChange={Edit ? undefined : (e) => onChangeTemperature(e)}
          value={Edit ? undefined : (ConvertTemp ? (form.temperatureF || "") : (form.temperature || ""))}
          onKeyDown={Edit ? undefined : HandleKeyDown}
        />
        <div className="component_temp_unit">
          {Auth.User.temperatureUnit.symbol}
        </div>
      </div>
      {!Edit && error["temperature"] &&
        <div className="component_row_error">
          {error["temperature"]}
        </div>
      }
      <div className="component_row_label" style={{ fontWeight: "bold", marginTop: "10px", color: "#4d4d4d" }}>
        {getLabel("ComponentEntity", "Pressure")}
      </div>
      <div className="component_row_input">
        <input
          className="page_text_input component_text_input"
          type="text"
          style={{ marginLeft: "40px" }}
          onChange={Edit ? undefined : (e) => onChangePressure(e)}
          value={Edit ? undefined : (form.pressure || "")}
          onKeyDown={Edit ? undefined : HandleKeyDown}
        />
        <div className="component_temp_unit" style={{ width: "40px" }}>
          PSIG
        </div>
      </div>
      {!Edit && error["pressure"] &&
        <div className="component_row_error">
          {error["pressure"]}
        </div>
      }
      <div className="component_row_label" style={{ fontWeight: "bold", marginTop: "10px", color: "#4d4d4d" }}>
        {getLabel("ComponentEntity", "Superheat")}
      </div>
      <div className="component_textzone_cont" style={{}}>
        {Edit ? "-" : Value.data ? Value.data + " °F" : "-"} 
      </div>

    </Fragment>
  );

};

export default ComponentSuperheat